

import {Component, Vue} from "vue-property-decorator"
import config from "@/config";
import type {ICrudOption} from "@/types/m-ui-crud"
import {IPage} from "@/apis/page";
import {checkoutApi, fruitTreeQueryApi, procurementCheckinApi, sourceNodeQueryApi} from "@/apis/linye";

@Component({})
export default class SourceNode extends Vue {
  config = config
  // 表格加载状态
  tableLoading: boolean = true;
  // 表格数据
  tableData: any[] = []
  // 表格总数
  tableTotal = 0
  // 查询参数
  queryParam: IPage = {
    page: 1,
    limit: 10
  }
  // 表单参数
  modelForm: Partial<any> = {}
  // crud配置信息
  crudOption: ICrudOption = {
    delBtn: false,
    searchBox: true,
    dialogWidth: '70%',
    labelWidth: '150px',
    column: [
      {
        label: "ID",
        type: "index",
        prop: "id",
        align: "center",
        width: 50,
        addHide: true,
        editHide: true
      },
      {
        label: "种植园名称",
        prop: "plantationName",
        align: "center",
        placeholder: "请输入种植园名称",
        width: '150px',
        search: true,
        addHide: true,
        editHide: true
      },
      {
        label: "品种名称",
        prop: "name",
        align: "center",
        placeholder: "请输入品种",
        search: true,
        addHide: true,
        editHide: true
      },
      {
        label: "种植日期",
        prop: "plantDate",
        type: "date",
        align: "center",
        addHide: true,
        editHide: true
      },
      {
        label: "树龄",
        prop: "treeAge",
        align: "center",
        addHide: true,
        editHide: true
      },
      {
        label: "状态",
        prop: "status",
        align: "center",
        addHide: true,
        editHide: true
      },
      {
        label: "种植园负责人",
        prop: "liaison",
        align: "center",
        addHide: true,
        editHide: true,
      },
      {
        label: "种植园负责人电话",
        prop: "liaisonPhone",
        align: "center",
        width: '130px',
        span: 12,
        addHide: true,
        editHide: true,
      },
    ]
  }

  getList() {
    this.tableLoading = true
    fruitTreeQueryApi(this.queryParam).then(e => {
      this.tableData = e.list
      this.tableTotal = e.total
      this.tableLoading = false
    })
  }

  nodeDialog: boolean = false
  sourceNodeTableLoading: boolean = false
  sourceNodeTable: any = {}
  sourceNodeTableParams: any = {}

  openSourceNodeDialog(row: any, index: number) {
    this.nodeDialog = true
    this.sourceNodeTableParams.limit = 10;
    this.sourceNodeTableParams.page = 1;
    this.sourceNodeTableParams.fruitTreeId = row.id;
    this.getSourceNodePage()
  }

  pagination(data: any) {
    this.sourceNodeTableParams.limit = data.limit;
    this.sourceNodeTableParams.page = data.page;
    this.getSourceNodePage()
  }

  getSourceNodePage() {
    this.sourceNodeTableLoading = true;
    sourceNodeQueryApi(this.sourceNodeTableParams).then(res => {
      this.sourceNodeTable = res
      this.sourceNodeTableLoading = false
    })
  }

  created() {
    this.getList()
  }
}
